import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from "@angular/router";
import {ErrorService} from "src/app/modules/error/error.service";

/**
 * Aide:
 * https://medium.com/angular-in-depth/top-10-ways-to-use-interceptors-in-angular-db450f8a62d6
 */

@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {

    constructor(private router: Router,
                private errorService: ErrorService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        console.log('Requete:', request);

        return next.handle(request).pipe(
                catchError(err => {
                    console.error('ErrorHttpInterceptor - error:', err);

                    if (err.status === 0) {
                        console.log("ErrorHttpInterceptor - Le serveur ne répond pas");
                        if (err.url.includes('sigman')) {
                            console.error("ErrorHttpInterceptor - Le serveur Sigman-internet ne répond pas -> affichage page erreur");
                            err.status = 500;
                            err.error.message = 'Le serveur Sigman n\'est pas opérationnel';
                        }
                    } else if (err.status === 400) {
                        console.log("ErrorHttpInterceptor - Mauvaise requête --> page 400?");
                        this.router.navigate(['400']);
                    } else if (err.status === 401) {
                        console.log("ErrorHttpInterceptor - L'utilisateur n'est pas authentifié --> page 401 ?");
                        this.router.navigate(['401']);
                    } else if (err.status === 403) {
                        console.log("ErrorHttpInterceptor - L'utilisateur n'a pas les droits nécessaires--> page 403 ?");
                        this.router.navigate(['403']);
                    } else if (err.status === 404) {
                        console.log("ErrorHttpInterceptor - La séance n'existe pas--> page 404 ?");
                        this.router.navigate(['404']);
                    } else if (err.status === 412) {
                        console.log("ErrorHttpInterceptor - 412:", err);
                        this.errorService.setErrorMessage(err.error.message);
                        this.router.navigate(['412']);
                    }

                    if (err.status >= 500) {
                        console.log(`ErrorHttpInterceptor - ${err.status}: ${this.router.routerState.snapshot.url}`);
                        let url;
                        if (this.router.routerState.snapshot.root.queryParams) {
                            url = this.router.routerState.snapshot.url.split('?')[0];
                        }
                        this.router.navigate(['error'], {state: {url: url, queryParams: this.router.routerState.snapshot.root.queryParams}});
                    }
                    return throwError(err);
                }))
    }
}
